import React from 'react';

type LogoProps = {
    viewBox: {X: number, Y: number, width: number, height: number},
    classes: string,
}
export default function Logo(props: LogoProps) {
    const {viewBox, classes} = props;
    return(
        // <svg viewBox="40 10 310 150" xml:space="preserve" id="danfoss" className="sc-htoDjs jsJExU">
        // <svg viewBox="40 10 310 150">
        <svg viewBox={`${viewBox.X} ${viewBox.Y} ${viewBox.width} ${viewBox.height}`} className={classes}>
            <g id="danfoss">
                <path d="M48.7,53.4c24.3-9.1,51.8-15,79.9-10.9l2.9-5.3c5.8-0.9,11.7-1.7,17.5-2.3l-7.8,11.9
                c7.6,3.3,13.9,11.3,14.6,19.7c0,11.4-5.1,20.9-10.9,29.7l8.5-1c5.7-9.3,21.7-20.5,28.3-12l2.3-3.2c0,0,10.5-1.6,10.7-1.6
                c-9.3,17.3-14.3,22-13.1,23.6c1.4,1.9,18.4-13.2,24.8-25.5l10.1-1.1l-5.7,10.1c10.2-8.4,13.9-13.8,19.6-11.4
                c7.9,3.3-9.4,21.7-7.5,22.9c1.6,1,15.5-9.2,22.2-19.5l-9.5,1.5l3.3-6.2l9.4-1.2c10.2-18.8,37-54.7,45.2-49.4
                c7.6,4.9-10.7,28.7-34.7,45.9l-1.5,2.7l20.8-2.3c0.4,0.2,0.6,0.9,0.1,1.3c-6.7,5.7-19.9,19.6-13,23.9c6.1,2.2,15.6-11.9,16.5-14.8
                c-5.4-1.7-1.1-16.8,6.6-14.8c5.2,1.8,1.3,9.2,0,12.1c9.9-1.2,18.8-11.3,18.8-11.3c-0.1-8,5-16.6,10.9-14.5c3.8,2,0.7,7.7-5.6,14.4
                c-0.8,0.8-0.4,3.9-0.5,7.6c6.7-2.3,14.3-5.5,20.6-8.6c0.1-7.7,3.9-17,10.4-15.1c4.7,1.4,0,10.9-5.9,15.7c-0.1,10.3,1.6,17.1-1,22.5
                c-3,6.2-13.4,11.4-19.6,7.8c-6.4-3.7-0.7-12,3.2-15.1c3.5-2.9,12.4-7,12.4-7s0.5-3.5,0.3-5.2c-3.5,2.1-20.2,8.3-20.2,8.3
                c-0.7,6.1-0.6,8.6-3.5,14.2c-3.6,6.9-15.5,9.7-19.5,5.8c-2.8-2.7-2-9.2,3.8-13.8c4.3-3.5,13.5-7.3,13.5-7.3s0.8-3.5,0.5-4.9
                c-5.9,5.1-12.6,10.2-21.2,10.4l0,0c-5.2,10.4-19.1,24.8-29,18.3c-9.6-6.2,5.9-22.6,7.4-23.8c-3.3,0.2-9.6,1.6-9.6,1.6l-16.9,31.3
                l0.2-0.1c0,0,57.7-6.6,110.1-6.7l-6.3,5.9c3,2.1,6.1,4.2,9.3,6c0,0-54.6-2.4-117.5,2.8l-9.2,17.1l-11.4,0.8l9.9-17.1
                c0,0-28.6,0.9-91.4,9.4c0.7-1.3,0.9-1.6,1.9-3.3c55.9-10.8,93.7-13.6,93.7-13.6s8.8-15.1,8.4-14.8c-5.5,4.6-17.7,14.4-22.8,9.6
                c-3.7-4.6,9.2-19.3,7.7-20.5c-1.2-1-16.5,14.7-22,23.3c-3.1,0.2-8.9,0.9-8.9,0.9l4.4-8.6c-5,3.9-10.3,8.1-15.9,10.3
                c-1.6,0.6-5.2,0.8-6.7-3.4c0,0-11.3,10.2-18.9,6.3c-4.1-2.1-2.2-9.8-1.5-11.5l-9,1c-39,45.2-89.9,50.3-96,40.4
                c-6.5-10.6,16.6-24.8,48.2-34.8c0,0,28.1-50.6,27.6-51c-38.8-5.9-86.8,23.9-86.8,23.9L48.7,53.4z M63.5,134.9
                c4.6,5.8,42.7-0.3,68.5-32.3c-17.8,2.8-28.4,6.6-32.3,8c-8.4,13.7-11.9,18.7-15.1,18.2c-3.9-0.5,2.3-7.9,5.6-15
                C76.1,118.4,59.2,129.5,63.5,134.9z M104.6,103.3c10-2.7,25.6-5.2,30.9-5.8c4.5-7.3,19.1-31.6-1.8-39.2L104.6,103.3z M164.9,93.1
                c-3,4-6.2,10.7-3.8,12.6c2.5,1.9,9.3-4,11.6-6.9c3.9-5.1,7.1-12.1,4.7-13.4C173.6,83.4,167,90.3,164.9,93.1z M263.2,59.6
                c7.6-4.7,27-24,22.2-28.5C280.4,28.9,267.1,50.4,263.2,59.6z M297.8,82.5c-3.2,2.3-4.8,5.2-3.2,6.5c1.5,1.2,5.5-1.1,7.2-3.6
                c2.8-3.8,3.4-7.1,3.4-7.1S302.7,78.9,297.8,82.5z M323,81.2c-1.1,1-5.2,4.7-3.4,6.5c1.5,1.6,6-1.1,7.8-3.2c2.4-2.9,3.6-7.5,3.6-7.5
                S326.2,78.4,323,81.2z"
                >
                </path>
            </g>
        </svg>
    );
}
